import React, { Component } from 'react'
import { observer } from "mobx-react"
import { Icon, message } from 'antd'
import { claimWin as claimWinContract } from '../../contract/PoolWagersController'
import { claimWin as claimWinApi } from '../../api-calls/poolWagers'
@observer(["AuthStore", "UserStore", "TeamStore"])
class PoolGetPaid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payoutButton: <button className="custom-btn-primary" onClick={this.claimWin.bind(this)}>PAYOUT</button>

        };
        this.claimWin = this.claimWin.bind(this);
    }

    claimWin() {
        const { UserStore, AuthStore } = this.props;
        let authToken = AuthStore.userAuth.auth.accessToken;
        let wager = this.props.bet;
        let wagerId = wager._id;
        let self = this;
        claimWinContract(wager.bytes32Id).then(
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! Bet not finalized.");
                } else {
                    return claimWinApi(
                        wagerId,
                        UserStore.user._id
                    ).then(function () {
                        self.setState({ payoutButton: <Icon style={{ fontSize: '16px', color: '#27f727' }} theme="outlined" type="check-circle" /> });
                        return UserStore.updateUser(authToken);
                    });
                 }
             });

    }

    render() {

        return (
            <div>
                {this.state.payoutButton}
            </div>
        )
    }
}
export default PoolGetPaid;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/PoolGetPaid.js